import React, { useEffect, useState } from "react";
import { ContentWrapper } from "../../utils/components";
import '../../styles/Reviews.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';

const Reviews = () => {
    const [reviews, setReviews] = useState([]);

    const fetchReviews = async () => {
        try {
            const response = await fetch('https://www.autoservicethomas.be/api/reviews/visible');
            const data = await response.json();
            setReviews(data);
        } catch (error) {
            console.error('Fout bij ophalen meldingen:', error);
        }
    }

    useEffect(() => {
        fetchReviews();
    });

    const getPlaceholder = (firstName, lastName) => {
        const fullName = `${firstName} ${lastName}`;
        const initials = fullName.split(" ").map((n) => n[0]).join("");
        return `https://placehold.co/60x60?text=${initials}`;
    }

    return (
        <div>
            {
                reviews?.length > 0 && (
                    <section className="section reviews-section" >
                        <ContentWrapper>
                            <h2 className="title reviews-title">Onze klanten zeggen...</h2>
                            <div className="reviews-grid">
                                {reviews.map((review) => (
                                    <div key={review._id} className="review-card">
                                        <div className="review-header">
                                            <img src={getPlaceholder(review?.firstName, review?.lastName)} alt={`${review?.firstName} ${review?.lastName}`} className="review-avatar" />
                                            <div>
                                                <h3 className="review-author">{`${review?.firstName} ${review?.lastName}`}</h3>
                                                <p className="review-date">{review?.date}</p>
                                            </div>
                                        </div>
                                        <div className="review-rating">
                                            {Array.from({ length: review?.rating }).map((_, i) => (
                                                <FontAwesomeIcon key={i} icon={faStar} className="review-star" />
                                            ))}
                                        </div>
                                        <p className="review-text">{review?.message}</p>
                                    </div>
                                ))}
                            </div>
                        </ContentWrapper>
                    </section >
                )}
        </div>
    );
}

export default Reviews;